<template>
    <div class="m-m">
        <h1>LUMI-O Credentials Management Service</h1>
        <p>Unfortunately the system is unable to map authentication credentials to LUMI user. Verify that you are using the right authentication method.</p>
        <p>If problem persists, Please contact your <a href="https://lumi-supercomputer.eu/user-support/need-help/">LUMI user support</a>.</p>
        <a href="/">Return home</a>
    </div>
</template>

<script>
export default {
    name: "LoginLocked",
}
</script>